import type {
  PassengerSchemaType,
  PassengersSchemaType,
} from "@/shared/schemas/flight/passengersSchema";

export const defaultPassengerData = (
  type: "adult" | "child" | "infant",
  price: number,
  isForeign: boolean,
): PassengerSchemaType => ({
  en_first_name: "",
  en_last_name: "",
  birth_date: {
    day: "",
    month: "",
    year: "",
  },
  gender: "male",
  na_code: "",
  isForeign,
  isInternational: false,
  nationality: "IRN",
  passport_expire: {
    day: "",
    month: "",
    year: "",
  },
  passport_nationality_code: "",
  passport_number: "",
  type: type,
  price,
});

export const defaultPassengersData = (
  price: {
    adult: number;
    child: number;
    infant: number;
  },
  passengersCount: {
    adult: string;
    child: string;
    infant: string;
  },
  isForeign: boolean,
): PassengerSchemaType[] => {
  const { adult, child, infant } = passengersCount;
  return [
    ...(adult ? new Array(+adult).fill({ type: "adult" }) : []),
    ...(child ? new Array(+child).fill({ type: "child" }) : []),
    ...(infant ? new Array(+infant).fill({ type: "infant" }) : []),
  ].map(({ type }) =>
    defaultPassengerData(type, price[type as keyof typeof price], isForeign),
  );
};

const defaultFormData = ({
  price,
  email,
  phone,
  flights,
  passengers,
  passengersCount,
  isForeign,
}: {
  price: {
    adult: number;
    child: number;
    infant: number;
  };
  email: string;
  phone: string;
  flights: (string | undefined)[] | undefined;
  passengers: PassengerSchemaType[] | null;
  passengersCount: {
    adult: string;
    child: string;
    infant: string;
  };
  isForeign: boolean;
}): PassengersSchemaType => ({
  passengers:
    passengers ?? defaultPassengersData(price, passengersCount, isForeign),
  email,
  phone,
  flights: flights,
});

export default defaultFormData;
